import { render, staticRenderFns } from "./DrivingSchoolActions.vue?vue&type=template&id=56fb028a&lang=pug&"
import script from "./DrivingSchoolActions.vue?vue&type=script&lang=js&"
export * from "./DrivingSchoolActions.vue?vue&type=script&lang=js&"
import style0 from "./DrivingSchoolActions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports